import { getTextFromHtml } from '@features/modal-invitation/lib/getTextFromHtml';
import { sanitizeEditorHtml } from '@shared/libs/sanitize-editor-html';
import { InvitationLinkIcon } from '../../../InvitationLinkIcon';
import styles from './ticket-preview.module.scss';

interface TicketPreviewProps {
  isSmsTicketMode: boolean;
  ticketText: string;
  previewLink: string;
}

export const TicketPreview = ({ isSmsTicketMode, ticketText, previewLink }: TicketPreviewProps) => {
  const hasTicketContent = !!getTextFromHtml(ticketText).trim();

  return (
    <div className={styles.settingsCardPreviewBlock}>
      <div className={styles.settingsCardPreviewContent}>
        <div className={styles.settingsCardPreviewSection}>
          <h3 className={styles.settingsCardPreviewLabel}>Предварительный просмотр билета</h3>
          <div className={styles.settingsCardPreviewContentInner}>
            {hasTicketContent &&
              (isSmsTicketMode ? (
                <div className={styles.settingsCardPreviewMessage}>{ticketText}</div>
              ) : (
                <div className={styles.settingsCardPreviewMessage}>
                  <div dangerouslySetInnerHTML={{ __html: sanitizeEditorHtml(ticketText) }} />
                </div>
              ))}
            <div className={styles.settingsCardPreviewLinkRow}>
              <InvitationLinkIcon />
              <div className={styles.settingsCardPreviewLink}>{previewLink}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
